// MUST come after i18n because of build order.
import { CUSTOM_EVENTS_MAP } from '@/setup/globals';
import useNotificationStore from '@/stores/notification';


const options = {
  setup() {
    return {
      notificationStore: useNotificationStore(),
    };
  },
  mounted() {
    window.addEventListener(CUSTOM_EVENTS_MAP.touchStart, this.enableTouchSupport);
    window.addEventListener(CUSTOM_EVENTS_MAP.notificationShow, this.onShowNotification);
  },
  unmounted() {
    window.removeEventListener(CUSTOM_EVENTS_MAP.touchStart, this.enableTouchSupport);
    window.removeEventListener(CUSTOM_EVENTS_MAP.notificationShow, this.onShowNotification);
  },
  methods: {
    /**
     * Adds an identifier class to the body element in case the user performed a touch gesture.
     */
    enableTouchSupport() {
      window.document.body.classList.add('uses-touch');

      window.removeEventListener(CUSTOM_EVENTS_MAP.touchStart, this.enableTouchSupport);
    },

    /**
     * This function is triggered to display a notification.
     *
     * @param {Object} event - The custom event object.
     * @param {Object} event.detail - The custom details of the events.
     * @param {Object} event.detail.message - The message configuration.
     * @param {String} event.detail.message.type - The message type (success, error, warning, info).
     * @param {String} event.detail.message.message - The message text.
     */
    onShowNotification(event) {
      this.notificationStore.showNotification({
        message: event.detail,
      });
    },
  },
};

export default options;
